// extracted by mini-css-extract-plugin
export default {"container":"container____Xjl0"};